import React from 'react';
import {FormattedMessage} from 'react-intl';
import * as _ from 'lodash';
import moment from 'moment/moment';

export function CardConfirmColumnFormatter(row) {
  const createdAt = _.get(row, 'createdAt', '')
    ? moment(_.get(row, 'createdAt', '')).format('DD-MM-YYYY HH:mm') : '';
  const agentID = _.get(row, 'agentID', '');
  const agentName = _.get(row, 'agentName', '');
  const customerName = _.get(row, 'customerName', '');
  const phone = _.get(row, 'phone', '');
  const total = _.get(row, 'total', '');
  const statusText = _.get(row, 'statusText', '');
  const rivhitStatusText = typeof _.get(row, 'rivhitStatusText', '') === 'string'
    ? _.get(row, 'rivhitStatusText') : '';
  const prefix = 'invoice-orders-column';
  const containerClassnames = 'd-flex align-items-center border';
  const labelClassnames = 'custom-brand-color font-weight-bolder bg-secondary py-2 px-1 w-75px';
  const fontStyles = {fontSize: 11};
  const itemClassnames = 'text-dark-75 font-weight-bold px-1';

  return (
    <div className={'border'}>
      <div className={containerClassnames}>
        <div className={labelClassnames} style={fontStyles}>
          <FormattedMessage id={`${prefix}-createdAt`} defaultMessage={'Created at'}/>:
        </div>
        <div className={itemClassnames} style={fontStyles}>{createdAt}</div>
      </div>
      <div className={containerClassnames}>
        <div className={labelClassnames} style={fontStyles}>
          <FormattedMessage id={`${prefix}-agent`} defaultMessage={'Agent'}/>:
        </div>
        <div>
          <div className={itemClassnames} style={fontStyles}>{agentID}</div>
          <div className={itemClassnames} style={fontStyles}>{agentName}</div>
        </div>
      </div>
      <div className={containerClassnames}>
        <div className={labelClassnames} style={fontStyles}>
          <FormattedMessage id={`${prefix}-customerName`} defaultMessage={'Customer name'}/>:
        </div>
        <div className={itemClassnames} style={fontStyles}>{customerName}</div>
      </div>
      <div className={containerClassnames}>
        <div className={labelClassnames} style={fontStyles}>
          <FormattedMessage id={`${prefix}-phone`} defaultMessage={'Phone'}/>:
        </div>
        <div className={itemClassnames} style={fontStyles}>{phone}</div>
      </div>
      <div className={containerClassnames}>
        <div className={labelClassnames} style={fontStyles}>
          <FormattedMessage id={`${prefix}-totalAmount`} defaultMessage={'Amount'}/>:
        </div>
        <div className={itemClassnames} style={fontStyles}>{total}</div>
      </div>
      <div className={containerClassnames}>
        <div className={labelClassnames} style={fontStyles}>
          <FormattedMessage id={`${prefix}-status`} defaultMessage={'Status'}/>:
        </div>
        <div>
          <div className={itemClassnames} style={fontStyles}>{statusText}</div>
          <div className={itemClassnames} style={fontStyles}>{rivhitStatusText}</div>
        </div>
      </div>
    </div>
  );
}
